import React, { useState, useEffect } from "react";
import "./Navbar.scss";
import logo from "../../../assets/logo/logo.png";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { signOut } from "firebase/auth";
import { auth } from "../../../features/firebase";
import { useCookies } from "react-cookie";
import useAuthStore from "../../../features/store";
import Loading from "../Loading/Loading";

const Navbar = ({ user }) => {
  const [navbarActive, setNavbarActive] = useState(false);
  const [navigationActive, setNavigationActive] = useState(false);
  const [navbarActiveMobile, setNavbarActiveMobile] = useState(false);
  // eslint-disable-next-line
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [loading, setLoading] = useState(false);

  // const navigate = useNavigate();

  const { userDB, clearUserDB } = useAuthStore();

  const navigateToInstagram = (url) => {
    window.location.href = url;
  };

  useEffect(() => {
    document.body.style.overflow = navbarActiveMobile ? "hidden" : "scroll";
  }, [navbarActiveMobile]);

  const handleMenuToggle = () => {
    setNavbarActive((prev) => !prev);
    if (navbarActive) {
      setNavigationActive(false);
    }
  };

  const handleMobileMenuToggle = () => {
    setNavbarActiveMobile((prev) => !prev);
  };

  const handleLogout = async () => {
    try {
      setLoading(true);
      await signOut(auth);
      removeCookie("user");
      clearUserDB();
      console.log("Logout berhasil");
    } catch (error) {
      console.error("Error saat logout:", error);
    } finally {
      setLoading(false);
    }
  };

  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + "...";
    } else {
      return str;
    }
  };
  // const handleDeleteAccount = async () => {
  //   try {
  //     setLoading(true);
  //     const user = auth.currentUser;
  //     if (user) {
  //       await deleteUser(user);
  //       removeCookie("user");
  //       navigate("/"); // Arahkan ke halaman utama setelah menghapus akun
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     if (error.code === "auth/requires-recent-login") {
  //       navigate(`/checkpoint/hapus-akun?uid=${cookies.user.uid}`);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <nav className="flying-nav">
      {loading && <Loading />}
      <section className="nav-left">
        <div className="nav-logo">
          <img
            onClick={() =>
              navigateToInstagram(
                "https://www.instagram.com/smanrogtb_oFFicial/"
              )
            }
            className="nav-logo-img-tarbud"
            src="https://telegra.ph/file/35bf7773b08600ce79e17.png"
            alt="Tarbud Logo"
          />
          <img className="nav-logo-img" src={logo} alt="KIRMAGO Logo" />
          <div className="nav-logo-text">
            <h2>KIRMAGO</h2>
            <p>Kreatif, Inovatif, Bisa Dan Berbeda</p>
          </div>
        </div>
      </section>
      <section className="nav-right">
        <div className="nav-textbar">
          <Link to="/">Copyright</Link>
          <Link to="/">License</Link>
        </div>
        <div className="nav-searchbar">
          <div className="nav-searchbar-wrapper">
            <input placeholder="Cari Sesuatu..." type="text" />
            <span className="material-symbols-rounded">search</span>
          </div>
        </div>
        <div className="nav-iconbar">
          <i className="fa-brands fa-facebook"></i>
          <i
            onClick={() =>
              navigateToInstagram("https://www.instagram.com/kirmago_smanrog/")
            }
            className="fa-brands fa-instagram"
          ></i>
          <span
            onClick={handleMenuToggle}
            className="desktop material-symbols-rounded"
          >
            {navbarActive ? "close" : "menu"}
          </span>
          <span
            onClick={handleMobileMenuToggle}
            className="mobile material-symbols-rounded"
          >
            {navbarActiveMobile ? "close" : "menu"}
          </span>
        </div>
      </section>
      <AnimatePresence>
        {navbarActive ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="nav-menu-desktop"
          >
            <div className="nav-md">
              <div className="nav-md-wrapper">
                {user && (
                  <div className="nav-md-login">
                    <div className="nav-md-login-text">
                      <div className="nav-mdlt-split">
                        {userDB ? (
                          <p>
                            {userDB.registered ? "registered" : "unregistered"}
                          </p>
                        ) : (
                          <Link className="mskd" to="/registrasi-profil">
                            unregistered
                          </Link>
                        )}
                        {userDB ? <p>{userDB.role}</p> : ""}
                        {!user.emailVerified && (
                          <Link className="mskd" to="/verifikasi">
                            unactive
                          </Link>
                        )}
                      </div>

                      {userDB && userDB.namaPanggilan ? (
                        <h3>{userDB.namaPanggilan}</h3>
                      ) : (
                        <h3>
                          {user.displayName
                            ? truncateString(user.displayName, 20)
                            : truncateString(user.email, 12)}
                        </h3>
                      )}
                    </div>
                    <div className="nav-md-login-pfp">
                      <img
                        src={
                          user.photoURL
                            ? user.photoURL
                            : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                        }
                        alt="src"
                      />

                      {userDB && userDB.role === "admin" ? (
                        <img
                          src="https://svgshare.com/i/18T5.svg"
                          alt="admin"
                          className="cat-ver"
                        />
                      ) : (
                        <>
                          {!user.emailVerified ? (
                            <img
                              src="https://svgshare.com/i/18T4.svg"
                              alt="unverified"
                              className="cat-ver"
                            />
                          ) : (
                            <img
                              src="https://svgshare.com/i/18SG.svg"
                              alt="verified"
                              className="cat-ver"
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
                <div className="nav-md-router">
                  {!user ? (
                    <Link className="nav-mdr-self" to="/login">
                      <i className="fa-solid fa-right-to-bracket"></i>
                      <p>login</p>
                    </Link>
                  ) : (
                    <Link className="nav-mdr-self" onClick={handleLogout}>
                      <i className="fa-solid fa-right-from-bracket"></i>
                      <p>logout</p>
                    </Link>
                  )}
                  {user ? (
                    <Link className="nav-mdr-self" to="/login">
                      <i className="fa-solid fa-user"></i>
                      <p>Dashboard</p>
                    </Link>
                  ) : (
                    <Link className="nav-mdr-self" to="/registrasi-akun">
                      <i className="fa-solid fa-user-plus"></i>
                      <p>Registrasi</p>
                    </Link>
                  )}

                  {/* <div className="nav-mdr-self" onClick={handleDeleteAccount}>
                    <i class="fa-solid fa-trash"></i>
                    <p>Delete Account</p>
                  </div> */}

                  <div className="nav-mdr-self">
                    <i className="fa-sharp fa-solid fa-plus"></i>
                    <p>More</p>
                  </div>

                  <div
                    onClick={() => setNavigationActive(!navigationActive)}
                    style={{
                      backgroundColor: navigationActive
                        ? "var(--primary-bg-col-darken)"
                        : "",
                    }}
                    className="nav-mdr-self"
                  >
                    {navigationActive ? (
                      <i className="fa-solid fa-xmark"></i>
                    ) : (
                      <i className="fa-solid fa-location-arrow"></i>
                    )}
                    <p>navigation</p>
                  </div>
                </div>
              </div>
            </div>
            <AnimatePresence>
              {navigationActive ? (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="navigation-router"
                >
                  <div className="nav-mdr-in">
                    <i className="fa-sharp fa-solid fa-people-group"></i>
                    <p>Anggota</p>
                  </div>
                  <div className="nav-mdr-in">
                    <i className="fa-solid fa-newspaper"></i>
                    <p>Artikel</p>
                  </div>
                  <div className="nav-mdr-in">
                    <i className="fa-solid fa-user-group"></i>
                    <p>Alumni</p>
                  </div>
                  <div className="nav-mdr-in">
                    <i className="fa-solid fa-folder"></i>
                    <p>Arsip data</p>
                  </div>
                </motion.div>
              ) : (
                ""
              )}
            </AnimatePresence>
          </motion.div>
        ) : (
          ""
        )}
      </AnimatePresence>

      <AnimatePresence>
        {navbarActiveMobile && (
          <motion.div
            className="nav-menu-mobile"
            initial={{ height: 0 }}
            animate={{ height: "100%" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <span
              onClick={handleMobileMenuToggle}
              className="mobile material-symbols-rounded"
            >
              close
            </span>
            <p>{user && user.displayName}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
